export default (state = false, action = {}) => {
  switch (action.type) {
    case 'USER_SAVING':
      return action.payload;
    default:
      return state;
  }
};
